module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    attrs: {
      "id": "content-wrap"
    }
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('strong', [_vm._v("\n      " + _vm._s(this.$route.name.toUpperCase()) + "\n    ")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])], 1), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_c('b', [_vm._v(_vm._s(this.$route.name))])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('transition', {
    attrs: {
      "name": "page",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-05ab5140!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ContentWrap.vue
// module id = 751
// module chunks = 0